module.exports = __webpack_public_path__ + "img/dbt.ba4c47b4.png";